import { Component } from "@angular/core";
import { NavController, NavParams } from "ionic-angular";
import { ModalController } from "ionic-angular";
import { AlertController } from "ionic-angular";
import { Observable } from "rxjs/Rx";
import { Member } from "../../models/interfaces/member.model";
import { AuthService } from "../../providers/dbservice/authservice";
import { DbserviceProvider } from "../../providers/dbservice/dbservice";
import { ConfigService } from '../../providers/dbservice/configservice';

@Component({
  selector: "page-runcount",
  templateUrl: "runcount.html",
})

export class RunCountPage {
  public static readonly HARELINE_ADD_ACCESS = "addHareline";
  private currentUser: Member;
  private runScore: number;

  private tmpSearchObject_Unpaid;
  private runcount_50 = [];
  private runcount_100 = [];
  private runcount_300 = [];
  private runcount_500 = [];
  private runcount_700 = [];
  private runcount_1000 = [];
  private runcount_1000_plus = [];
  private runcount = [];
  private styleName: string ="";

  constructor(private configService: ConfigService,public authService: AuthService, public navCtrl: NavController, public navParams: NavParams,
    public alertCtrl: AlertController,
    private db: DbserviceProvider, public modalCtrl: ModalController,
  ) {
    console.log("RunCountPage constructor");
    this.styleName=this.configService.getConfig("STYLENAME");

  }

  private ionViewWillEnter() {
    console.log("RunCountPage ionViewWillEnter");
    if (this.authService.currentUser) {
    }
    this.onInitPage();
  }

  private onInitPage() {
    console.log("RunCountPage onInitPage");

    this.db.dbCol({
      "action": "select", "mapObject": "vw_attendance_summarized",
      "sqlExtended": " where st_id in (1,2,4,5) order  by rc_runcount desc, mb_hashname",
    }).subscribe((rc) => {
      this.runcount = rc;

      this.runcount_50 = rc.filter(function (o) {
        return o.rc_runcount <= 50 && o.rc_runcount >= 0;
      });
      this.runcount_100 = rc.filter(function (o) {
        return o.rc_runcount <= 100 && o.rc_runcount >= 51;
      });
      this.runcount_300 = rc.filter(function (o) {
        return o.rc_runcount <= 300 && o.rc_runcount >= 101;
      });
      this.runcount_500 = rc.filter(function (o) {
        return o.rc_runcount <= 500 && o.rc_runcount >= 301;
      });
      this.runcount_700 = rc.filter(function (o) {
        return o.rc_runcount <= 700 && o.rc_runcount >= 501;
      });
      this.runcount_1000 = rc.filter(function (o) {
        return o.rc_runcount <= 1000 && o.rc_runcount >= 701;
      });
      this.runcount_1000_plus = rc.filter(function (o) {
        return o.rc_runcount <= 5000 && o.rc_runcount >= 1001;
      });

    });
  }

  private getColor(rc) {
    console.log("RunCountPage getColor");
    if ([49, 50, 99, 100, 199, 200, 299, 300, 399, 400, 499, 500, 599, 600, 699, 700, 799, 800, 899, 900, 999, 1000, 1099, 1100, 1199, 1200, 1299, 1300, 1399, 1400, 1499, 1500, 1599, 1600, 1699, 1700, 1799, 1800, 1899, 1900, 1999, 2000, 2099, 2100, 2199, 2200, 2299, 2300, 2399, 2400].includes(Number(rc))) {
      return '#FF0000'

    } else if ([48, 98, 198, 298, 398, 498, 598, 698, 798, 898, 998, 1098, 1198, 1298, 1398, 1498, 1598, 1698, 17991898, 1998, 2098, 2198, 2298, 2398].includes(Number(rc))) {
      return '#ff9999'

    } else if ([47, 97, 197, 297, 397, 497, 597, 697, 797, 897, 997, 1097, 1197, 1297, 1397, 1497, 1597, 1697, 17991897, 1997, 2097, 2197, 2297, 2397].includes(Number(rc))) {
      return '#ff9999'
    } else {
      return '#000000'
    }

  }

  private getLineSelected(rc) {
    console.log("RunCountPage getLineSelected");
    let list: number[] = [49, 50, 99, 100, 199, 200, 299, 300, 399, 400, 499, 500, 599, 600, 699, 700, 799, 800, 899, 900, 999, 1000, 1099, 1100, 1199, 1200, 1299, 1300, 1399, 1400, 1499, 1500, 1599, 1600, 1699, 1700, 1799, 1800, 1899, 1900, 1999, 2000, 2099, 2100, 2199, 2200, 2299, 2300, 2399, 2400];

    if ([49, 50, 99, 100, 199, 200, 299, 300, 399, 400, 499, 500, 599, 600, 699, 700, 799, 800, 899, 900, 999, 1000, 1099, 1100, 1199, 1200, 1299, 1300, 1399, 1400, 1499, 1500, 1599, 1600, 1699, 1700, 1799, 1800, 1899, 1900, 1999, 2000, 2099, 2100, 2199, 2200, 2299, 2300, 2399, 2400].includes(Number(rc))) {
      return 1
    }
    else {
      return 0
    }
  }

  private unique(arr, keyProps) {
    const kvArray = arr.map(entry => {
      const key = keyProps.map(k => entry[k]).join('|');
      return [key, entry];
    });
    const map = new Map(kvArray);
    return Array.from(map.values());
  }

  private ngOnDestroy() {
    console.log("RunCountPage ngOnDestroy");
    this.runcount = null;
  }

}



// WEBPACK FOOTER //
// ./src/pages/runcount/runcount.ts